export const selectRegularizations = (state) =>
  state.regularization?.regularizations || [];

export const selectRegularizationsLoading = (state) =>
  state.regularization?.loading || false;

export const selectRegularizationsActionLoading = (state) =>
  state.regularization?.actionLoading || false;

export const selectRegularizationsError = (state) =>
  state.regularization?.error || null;

export const selectRegularizationsPagination = (state) =>
  state.regularization?.pagination || {};
